import type { HelpFile } from '../../types/help'
import { RevokeApiKeyDialogTestIds } from '../../../testids/RevokeApiKeyDialogTestIds'

export const revokeApiKeyDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [RevokeApiKeyDialogTestIds.revokeDialogTitle]: null,
    [RevokeApiKeyDialogTestIds.revokeDialogBody]: null,
    [RevokeApiKeyDialogTestIds.btnCancelRevokeKey]:
      'Den Dialog schließen, ohne den Schlüssel zu widerrufen.',
    [RevokeApiKeyDialogTestIds.btnConfirmRevokeKey]:
      'Diesen API-Schlüssel dauerhaft widerrufen. Authentifizierung mit dem Schlüssel schlägt sofort fehl. Idempotent — ein erneutes Widerrufen zeigt dieselbe Erfolgsmeldung.',
  },
}
